import React from 'react';
import { remotePaths } from 'router/routes';

const helpLink = remotePaths.help;

export default [
  {
    name: 'showDebtsWriteOffMessage',
    content: (
      <div className="red">
        В соответствии с налоговой амнистией 2018 года Вам произведено списание налоговой
        задолженности. Подробнее с информацией о налоговой амнистии Вы можете ознакомиться:
        <ul>
          <li>
            <a href={remotePaths.taxes}>На странице "История операций"</a>
          </li>
          <li>
            <a target="_bank" href="https://nalog.ru">
              На сайте ФНС России
            </a>
          </li>
        </ul>
      </div>
    ),
  },
  {
    name: 'hasChangesToAccept',
    content: (
      <div className="red">
        Из регистрирующих органов поступили сведения об изменении характеристик&nbsp;
        <a href={remotePaths.propertyObjects}>Вашего имущества</a>. Федеральная&nbsp; налоговая
        служба просит Вас проверить эти сведения и подтвердить корректность новых характеристик,
        либо не&nbsp; подтвердить и направить заявление в ФНС России об уточнении характеристик
        Вашего имущества.
      </div>
    ),
  },
  {
    name: 'needEmail',
    content: (
      <div className="red">
        Вы не заполнили Ваш электронный адрес. Пожалуйста, перейдите по этой&nbsp;
        <a href={remotePaths.profile}>ссылке</a>, введите Ваш электронный адрес&nbsp; и подтвердите
        его. Через несколько часов Ваши персональные данные обновятся.&nbsp;
        <a href={helpLink}>Зачем нужно заполнять адрес электронной почты?</a>
      </div>
    ),
  },
];
